import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { featureQueries } from '../../../api/features'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { SpinnerWrapper } from '../../common/SpinnerWrapper'
import { FeatureFlagCard } from './FeatureFlagCard'

export const FeatureFlags = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { data, isLoading, isError } = useQuery(
    featureQueries.featureFlagList()
  )

  if (isLoading) {
    return <SpinnerWrapper />
  }

  if (isError || data == null) {
    return (
      <p style={theme.textVariants.base}>
        {translate('flashMessage.somethingWentWrongError')}
      </p>
    )
  }

  if (data.flags.length === 0) {
    return (
      <p style={theme.textVariants.base}>
        {translate('adminView.featureFlags.empty')}
      </p>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      {data.flags.map((flag) => (
        <FeatureFlagCard key={flag.feature} flag={flag} />
      ))}
    </div>
  )
}
